"use client";

import { Box, Text } from "@chakra-ui/react";
import { Highlight } from "react-instantsearch";
import type { MeiliThought } from "@/generated/fastapi";
import {
  type MeiliDocumentSearchHit,
  MEILI_SEARCH_CONFIG,
} from "@/features/search";
import { CONTENT_ITEM_HIGHLIGHT_STYLES } from "@/shared/ui/display/ContentItemPrimitives";
import { CONTENT_ITEM_TEXT_PROPS } from "@/shared/ui/display/ContentItemPrimitives";

const SEARCH_PREVIEW_LINE_CLAMP = { base: 5, md: 4 } as const;
const NON_SEARCH_PREVIEW_LINE_CLAMP = { base: 6, md: 5 } as const;

type ThoughtItemPreviewProps = {
  config: (typeof MEILI_SEARCH_CONFIG)[keyof typeof MEILI_SEARCH_CONFIG];
  hit: MeiliDocumentSearchHit;
  isInSearchContext: boolean;
  thought: MeiliThought;
};

export default function ThoughtItemPreview({
  config,
  hit,
  isInSearchContext,
  thought,
}: ThoughtItemPreviewProps) {
  if (!isInSearchContext) {
    return (
      <Text
        color="moveon.surface.fg"
        lineClamp={NON_SEARCH_PREVIEW_LINE_CLAMP}
        {...CONTENT_ITEM_TEXT_PROPS}
      >
        {thought.mindstring}
      </Text>
    );
  }

  return (
    <Box
      color="moveon.surface.fg"
      css={{
        ...CONTENT_ITEM_HIGHLIGHT_STYLES,
        "& mark": {
          ...CONTENT_ITEM_HIGHLIGHT_STYLES["& mark"],
          background: "var(--chakra-colors-yellow-200)",
        },
      }}
    >
      <Text
        lineClamp={SEARCH_PREVIEW_LINE_CLAMP}
        {...CONTENT_ITEM_TEXT_PROPS}
      >
        <Highlight
          attribute={config.mainContentField}
          hit={hit}
          highlightedTagName="mark"
        />
      </Text>
    </Box>
  );
}
